import React, { Component } from 'react';
import { projects } from 'data/projects.json';

import Carousel from 'components/carousel';
import Iphone from 'components/iphone';
import {
  ProjectDescription,
  ProjectIntro,
  ProjectPage,
} from 'components/project';

import styles from './styles.module.css';

import coverImage from 'components/project/img/Animalz.jpg';

const mobileImages = [
  {
    src: require('./img/left.png'),
    description: 'Life with Bird product listing mobile',
  },
  {
    src: require('./img/mid.png'),
    description: 'Life with Bird product mobile',
  },
  {
    src: require('./img/right.png'),
    description: 'Life with Bird cart mobile',
  },
];

export default class Animalz extends Component {
  render() {
    const project = projects.find(_project => _project.slug === 'animalz');

    const image = <img src={coverImage} alt="Cover" />;

    const iphone = (
      <Iphone invert>
        <Carousel images={mobileImages} />
      </Iphone>
    );

    const textStyle = {
      textAlign: 'left',
      fontSize: 20,
    };

    const speStyle = {
      fontWeight: 'bold',
      fontSize: 22,
    };

    return (
      <ProjectPage project={project}>
        <ProjectIntro project={project} media={image} />
        <ProjectDescription
          media={iphone}
          //  appleUrl={project.appleUrl}
          //  googleUrl={project.googleUrl}
        >
          <h2>Comment ça marche ?</h2>
          <wrapper className={styles.sectionImg}>
            <p style={textStyle}>
              Une <text style={speStyle}>Carte Intéractive</text> du lieu de
              l'évènement indique votre localisation.
            </p>
          </wrapper>

          <wrapper className={styles.sectionImg}>
            <p style={textStyle}>
              Une line up animée indique en{' '}
              <text style={speStyle}> Temps Réel</text> l'artiste sur scène (et
              le temps qu'il lui reste...).
            </p>
          </wrapper>

          <wrapper className={styles.sectionImg}>
            <p style={textStyle}>
              "Je t'attends devant les toilettes" mais quelles toilettes ?!{' '}
              <br />
              Ce genre de situation bien frustrante qui peut être évitée grâce
              aux <text style={speStyle}>Zones</text> indiquées sur la carte.
            </p>
          </wrapper>
          <wrapper className={styles.sectionImg}>
            <p style={textStyle}>
              Vous vous ennuyez pendant le trajet ? Occupez-vous avec le{' '}
              <text style={speStyle}>Quiz</text> Bass Musique.
            </p>
          </wrapper>
        </ProjectDescription>
      </ProjectPage>
    );
  }
}

/*
<h3>Après les présidentielle 2017 ?</h3>
<p>SwiPolitique deviendra SwipCity ! <br />
Vous pourrez swiper entre les différentes caractéristique des grandes villes, cela vous aidera peut-être à prendre votre prochaine destination de vacances.</p>

*/
/*
<h3>Mais est-ce que cela va m'interesser ?</h3>
<p>C'est simple si vous aimez faire des choix et que vous aimez le concret ? C'est que vous êtes surement un roi ou une reine. </p>
<p>Vous adoré l'ordre, l'organisation et analysé les details. Vous ne rateriez surement pas les prochaines votes aux éléctions </p>
<p>Si c'est le cas cette application est faite pour vous.</p>
*/

//          <OutboundLink to="http://inlight.com.au">Inlight</OutboundLink>

/*
<Macbook>
  <Carousel images={images} />
</Macbook>
*/



// WEBPACK FOOTER //
// ./work/animalz/index.jsx